import BaseService from '../BaseService';

class TopbarAlertService extends BaseService {

    checkAlerts = () => this.get('/warehouse/product/alert/check');
}

export default new TopbarAlertService();